<template>
  <div class="pulic-banner-container">
    <div class="banner-content">
      <div class="banner-txt">
        <slot></slot>
      </div>
      <i class="i-mouse"></i>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'Banner'
  };
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';
  // 公共banner样式
  .pulic-banner-container {
    width: 100%;
    height: 380px;
    -webkit-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
    .banner-content {
      @include public_content();
      height: 100%;
      position: relative;
      .banner-txt {
        width: 700px;
        position: absolute;
        left: 50%;
        top: 35%;
        transform: translate(-50%, -50%);
        color: #fff;
        text-align: center;
        text-shadow: 0 0 20px #082c32;
      }
      p {
        font-size: 30px;
        font-weight: normal;
        line-height: 2em;
        text-shadow: 0 0 20px #082c36;
      }
      span {
        font-size: 20px;
        font-weight: 600;
        line-height: 50px;
      }
      .i-mouse {
        width: 14px;
        height: 68px;
        display: block;
        background: url('../assets/images/i-mouse.png') no-repeat;
        position: absolute;
        bottom: 50px;
        left: 50%;
        margin-left: -14px;
      }
    }
  }

  .mobile {
    .pulic-banner-container{
      height: 3.94rem;
      .banner-content{
        width: 100%;
        .banner-txt{
          width: 100%;
          top: 40%;
          p{
            font-size: .40rem;
            color: #fff;
            line-height: 2em;
          }
        }
        .i-mouse{
          display: none;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Banner.vue